import { render } from "./Clients.vue?vue&type=template&id=42681d28&scoped=true&ts=true"
import script from "./Clients.vue?vue&type=script&lang=ts"
export * from "./Clients.vue?vue&type=script&lang=ts"

import "./Clients.vue?vue&type=style&index=0&id=42681d28&lang=scss&scoped=true"

import exportComponent from "/src/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42681d28"]])

export default __exports__